import { useCallback, useMemo } from "react";

import { useTranslation } from "react-i18next";

import { isEmpty, isEmptyObject } from "../../utils/validators";

function HelpToast(props) {
  const { data, closeToast } = props;

  const { t } = useTranslation();

  const message = useMemo(() => {
    if (!isEmptyObject(data) && !isEmpty(data.message)) {
      return data.message;
    }
    return "";
  }, [data]);

  const onContactHandler = useCallback(
    (evt) => {
      data && data.onContact && data.onContact(evt);
      closeToast && closeToast();
    },
    [data, closeToast]
  );

  return (
    <div className="help-toast__content">
      <p className="help-toast__message">{message}</p>
      <div
        role="button"
        className="help-toast__button"
        onClick={(evt) => onContactHandler(evt)}
      >
        {t("button.contact")}
      </div>
    </div>
  );
}

export default HelpToast;
